export default "__VITE_ASSET__d58c0df1__"